/**
 * Bridge client talkes to /bridge endpoint in ihub and are used to communicate to internal atlassian APIs
 */
import { post } from "./http.client";
import { getBaseURL } from "../../env/stage";

const BRIDE_URL = getBaseURL() + "/bridge";

export const callWithBasicAuth = (url, method, credentials, body = {}) => {
  let headers = [
    { key: "Content-Type", value: "application/json" },
    { key: "Connection", value: "keep-alive" },
    { key: "Accept-Encoding", value: "gzip, deflate, br" },
    { key: "Accept", value: "*/*" },
    { key: "User-Agent", value: "IntegrationsHub/cloud" },
    { key: "Cache-Control", value: "no-cache" },
  ];

  if (credentials) {
    headers.push({
      key: "Authorization",
      value: "Basic " + btoa(credentials.username + ":" + credentials.password),
    });
  }

  const bridgeObject = {
    url: url,
    method: method,
    headers: headers,
    body: body,
  };
  return post(BRIDE_URL, bridgeObject);
};

export const callWithCustomAuth = (url, method, authHeader, body = {}) => {
  let headers = [
    { key: "Content-Type", value: "application/json" },
    { key: "Connection", value: "keep-alive" },
    { key: "Accept-Encoding", value: "gzip, deflate, br" },
    { key: "Accept", value: "*/*" },
    { key: "User-Agent", value: "IntegrationsHub/cloud" },
    { key: "Cache-Control", value: "no-cache" },
  ];

  if (authHeader) {
    headers.push(authHeader);
  }

  const bridgeObject = {
    url: url,
    method: method,
    headers: headers,
    body: body,
  };
  return post(BRIDE_URL, bridgeObject);
};